module.exports = __webpack_public_path__ + "static/media/aku-kajan.ab844be2.jpg";